// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Iqqg-","ranges":"BmiRanges_ranges__3LZgh"};